import { gql } from 'react-apollo';

export const full = gql`
  fragment allUserFields on User {
    id
    type
    email
    name
    photo {
      small
    }
    department
    phone
    passwordCreated: password_created
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/fragments/user.js